import React from "react";
import LogoSvg from "../components/ui/LogoSvg";

const NotFoundPage = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "black",
        color: "white",
        height: "100vh",
        width: "100vw",
        fontFamily: "Poppins",
        fontSize: "1vw",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "1vw",
        }}
      >
        <LogoSvg height="6vw" width="8vw" />

        <p> Page Not Found </p>
      </div>
    </div>
  );
};

export default NotFoundPage;
